import React, { useLayoutEffect } from 'react';
import { Link } from 'gatsby';
import './Footer.scss';

export default () => {
  useLayoutEffect(() => {
    window.$('.height-emulator').css({
      height: window.$('.content-footer').outerHeight(true)
    });
  });
  return (
    <>
      <div className="height-emulator" />
      <footer className="content-footer">
        <div>
          <div className="row">
            <div className="col-md-3 clearfix">
              <div className="footer-item footer-logo">
                <Link to="/">
                  <img src="/images/logo.svg" alt="" />
                </Link>
              </div>
            </div>
            <div className="col-md-7">
              <div className="row">
                <div className="col-md-4 clearfix">
                  <div className="footer-item">
                    <h4 className="text-link">Telefon</h4>
                    <ul>
                      <li>
                        <a href="tel:+48606103792">(+48) 606 103 792</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-4 clearfix">
                  <div className="footer-item">
                    <h4 className="text-link">E-mail</h4>
                    <ul>
                      <li>
                        <a href="mailto:2m2biuro@gmail.com">2m2biuro@gmail.com</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="footer-wrap">
                    <span className="copyright"> &#169; Puresoft 2019.</span>
                    <span className="to-top">Powrót</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <canvas className="particular" />
      </footer>
    </>
  );
};
